import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFolder2: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="folder-2"><path d="M9.94444 3.75H2.75V19.25H21.25V5.75H12L9.94444 3.75Z" stroke="currentColor" strokeWidth="1.5"/><path d="M2.75 12.75V9.75H21.25V12.75" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconFolder2;
